<template>
  <div id="History">
    <div class="tr-header">
      <p class="title">开奖记录</p>
      <div class="dayHandles">
        <p @click="selectDay=today" :class="{'active':selectDay == today}">今天</p>
        <p @click="selectDay=yesterday" :class="{'active':selectDay == yesterday}">昨天</p>
        <p @click="selectDay=beforeYesterday" :class="{'active':selectDay == beforeYesterday}">前天</p>
        <DatePicker
          @on-change="dateChange"
          :value="selectDay"
          type="date"
          style="width: 200px;margin-left:10px"
        ></DatePicker>
      </div>
    </div>

    <div class="tr-header-container" v-if="!notype.includes(betType)">
      <div class="handle-con">
        <div class="title">
          <span>查看球号分布：</span>
          <div class="handles" style="display:inline-block;">
            <span
              class="handle"
              v-for="i in 10"
              v-if="betType == 'ssc'"
              :key="i"
              @click="handleSelectType(0,i-1)"
              :class="{'active':selectType === 0 && ~selectNumArr.indexOf(i-1)}"
            >号码{{i - 1}}</span>
            <span
              class="handle"
              v-for="i in 10"
              v-if="betType == 'PK10' || betType == 'nn'"
              :key="i"
              @click="handleSelectType(0,i)"
              :class="{'active':selectType === 0 && ~selectNumArr.indexOf(i)}"
            >号码{{i}}</span>
            <span
              class="handle"
              v-for="i in 11"
              v-if="betType == 'choose5'"
              :key="i"
              @click="handleSelectType(0,i)"
              :class="{'active':selectType === 0 && ~selectNumArr.indexOf(i)}"
            >号码{{i}}</span>
            <span
              class="handle"
              v-for="i in 20"
              v-if="betType == 'hpten'"
              :key="i"
              @click="handleSelectType(0,i)"
              :class="{'active':selectType === 0 && ~selectNumArr.indexOf(i)}"
            >号码{{i}}</span>
          </div>
        </div>
        <div class="title">
          <span>大小单双分布：</span>
          <div class="handles" style="display:inline-block;">
            <span
              class="handle"
              @click="handleSelectType(1,0)"
              :class="{'active':selectType === 1 && selectValue === 0}"
            >单</span>
            <span
              class="handle"
              @click="handleSelectType(1,1)"
              :class="{'active':selectType === 1 && selectValue === 1}"
            >双</span>
            <span
              class="handle"
              @click="handleSelectType(2,0)"
              :class="{'active':selectType === 2 && selectValue === 0}"
            >大</span>
            <span
              class="handle"
              @click="handleSelectType(2,1)"
              :class="{'active':selectType === 2 && selectValue === 1}"
            >小</span>
            <span
              class="handle"
              @click="handleSelectType(3,0)"
              :class="{'active':selectType === 3 && selectValue === 0}"
            >对子号</span>
            <!-- <span class="handle reset" @click="handleSelectType('','')">还原</span> -->
            <span class="handle reset" @click="handleSelectType('','')">还原</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tr-table-container">
      <Table :columns="columns" :data="dataSource" stripe border></Table>
      <div class="page">
        <Page :total="total" :page-size="50" @on-change="handleMoreData" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import columns from "./columns";

const today = dayjs(new Date()).format("YYYYMMDD");
const yesterday = dayjs(new Date())
  .add(-1, "day")
  .format("YYYYMMDD");
const beforeYesterday = dayjs(new Date())
  .add(-2, "day")
  .format("YYYYMMDD");

export default {
  name: "History",
  data() {
    return {
      pageSize: 50,
      startRow: 0,
      total: 0,
      loading: false,
      notype: ["xyrb", "ks", "three"],
      today,
      yesterday,
      beforeYesterday,
      selectDay: today,
      columns: [],
      dataSource: [],
      gameType: this.$route.params.gameType,
      tableShowBallType: 0, // 0 显示号码 1 显示大小 2显示单双
      selectType: "", //0号码 1单双 2大小 3对子号
      selectNumArr: [], //0号码可以多选
      selectValue: "" //0-9    01    01     0
    };
  },
  watch: {
    selectDay() {
      this.getData();
    }
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  created() {
    this.reset();
  },
  methods: {
    dateChange(date) {
      this.selectDay = date;
    },
    async init() {
      // this.reset();
      this.getData();
    },
    async handleMoreData(page) {
      this.loading = true;
      this.startRow = (page - 1) * 50;
      await this.init();
      this.loading = false;
    },
    reset() {
      this.tableShowBallType = 0;
      this.selectType = "";
      this.selectNumArr = [];
      this.selectValue = "";
      this.columns = columns(this.betType, this.gameType).list(this);
    },
    async getData() {
      // 排列一天一期,先展示 30 条
      if (this.betType == "three") {
        let lhcReq = {
          gameType: this.$route.params.gameType,
          isNeed: 1,
          num: 30,
          date: dayjs(this.selectDay).format("YYYY-MM-DD")
        };
        let lhcData = await this.$http.post("/queryKcReportByIssue.do", lhcReq);
        if (lhcData.data.returnCode == "0000") {
          this.dataSource = lhcData.data.returnList;
        } else {
        }
      } else {
        let res = await this.$http.post("/queryGameTypeResultByGameType.do", {
          gameType: this.$route.params.gameType,
          pageSize: this.pageSize,
          startRow: this.startRow,
          startDate: dayjs(this.selectDay).format("YYYYMMDD"),
          endDate: dayjs(this.selectDay).format("YYYYMMDD")
        });
        if (res.data.returnCode == "0000") {
          this.total = res.data.totalCount;
          this.dataSource = res.data.returnList;
        } else {
        }
      }
    },
    handleSelectType(type, value) {
      if (type === 0) {
        this.selectType = 0;
        this.selectValue = "";
        if (~this.selectNumArr.indexOf(value)) {
          this.selectNumArr.splice(this.selectNumArr.indexOf(value), 1);
          if (this.selectNumArr.length == 0) {
            this.selectType = "";
          }
        } else {
          this.selectNumArr.push(value);
        }
      } else {
        this.selectNumArr = [];
        if (this.selectValue === value && this.selectType === type) {
          this.selectValue = "";
          this.selectType = "";
        } else {
          this.selectType = type;
          this.selectValue = value;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
/deep/.ivu-table-wrapper {
  min-width: 1160px;
}
</style>




// WEBPACK FOOTER //
// src/pages/Trend/History/index.vue